const appInfo = {
    title: 'Taskpip Admin'
};
export default appInfo;

